export default {
  'pages.layouts.userLayout.title':
    'পিঁপড়া ডিজাইন হচ্ছে সিহু জেলার সবচেয়ে প্রভাবশালী ওয়েব ডিজাইনের স্পেসিফিকেশন',
  'pages.login.accountLogin.tab': 'অ্যাকাউন্টে লগইন',
  'pages.login.accountLogin.errorMessage':
    'ভুল ব্যবহারকারীর নাম/পাসওয়ার্ড(admin/ant.design)',
  'pages.login.failure': 'লগইন ব্যর্থ হয়েছে। আবার চেষ্টা করুন!',
  'pages.login.success': 'সফল লগইন!',
  'pages.login.username.placeholder': 'ব্যবহারকারীর নাম: admin or user',
  'pages.login.username.required': 'আপনার ব্যবহারকারীর নাম ইনপুট করুন!',
  'pages.login.password.placeholder': 'পাসওয়ার্ড: ant.design',
  'pages.login.password.required': 'আপনার পাসওয়ার্ড ইনপুট করুন!',
  'pages.login.phoneLogin.tab': 'ফোন লগইন',
  'pages.login.phoneLogin.errorMessage': 'যাচাইকরণ কোড ত্রুটি',
  'pages.login.phoneNumber.placeholder': 'ফোন নম্বর',
  'pages.login.phoneNumber.required': 'আপনার ফোন নম্বর ইনপুট করুন!',
  'pages.login.phoneNumber.invalid': 'ফোন নম্বরটি সঠিক নয়!',
  'pages.login.captcha.placeholder': 'যাচাইকরণের কোড',
  'pages.login.captcha.required': 'দয়া করে ভেরিফিকেশন কোডটি ইনপুট করুন!',
  'pages.login.phoneLogin.getVerificationCode': 'কোড পান',
  'pages.getCaptchaSecondText': 'সেকেন্ড',
  'pages.login.rememberMe': 'আমাকে মনে রাখুন',
  'pages.login.forgotPassword': 'পাসওয়ার্ড ভুলে গেছেন?',
  'pages.login.submit': 'প্রবেশ করুন',
  'pages.login.loginWith': 'লগইন করতে পারেন:',
  'pages.login.registerAccount': 'অ্যাকাউন্ট নিবন্ধন করুন',
  'pages.welcome.link': 'স্বাগতম',
  'pages.welcome.alertMessage': 'দ্রুত এবং শক্তিশালী ভারী শুল্ক উপাদান প্রকাশ করা হয়েছে।',
  'pages.404.subTitle': 'দুঃখিত, আপনি যে পৃষ্ঠাটি দেখতে চান তা বিদ্যমান নেই।',
  'pages.404.buttonText': 'প্রধান পাতায় ফিরে যান',
  'pages.admin.subPage.title': 'এই পৃষ্ঠাটি কেবল অ্যাডমিন দ্বারা দেখা যাবে',
  'pages.admin.subPage.alertMessage':
    'UMI UI এখন প্রকাশিত হয়েছে, অভিজ্ঞতা শুরু করতে npm run ui ব্যবহার করতে স্বাগতম।',
  'pages.searchTable.createForm.newRule': 'নতুন বিধি',
  'pages.searchTable.updateForm.ruleConfig': 'বিধি কনফিগারেশন',
  'pages.searchTable.updateForm.basicConfig': 'মৌলিক তথ্য',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'বিধি নাম',
  'pages.searchTable.updateForm.ruleName.nameRules': 'বিধির নাম লিখুন!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'বিধির বিবরণ',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'কমপক্ষে পাঁচটি অক্ষর লিখুন',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'কমপক্ষে পাঁচটি অক্ষরের একটি বিধান বিবরণ লিখুন!',
  'pages.searchTable.updateForm.ruleProps.title': 'বৈশিষ্ট্য কনফিগার করুন',
  'pages.searchTable.updateForm.object': 'নিরীক্ষণ অবজেক্ট',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'বিধি টেম্পলেট',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'বিধি প্রকার',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'সময়সূচী নির্ধারণ করুন',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'শুরুর সময়',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'একটি শুরুর সময় চয়ন করুন!',
  'pages.searchTable.titleDesc': 'বর্ণনা',
  'pages.searchTable.ruleName': 'বিধি নাম প্রয়োজন',
  'pages.searchTable.titleCallNo': 'পরিষেবা কল সংখ্যা',
  'pages.searchTable.titleStatus': 'অবস্থা',
  'pages.searchTable.nameStatus.default': 'ডিফল্ট',
  'pages.searchTable.nameStatus.running': 'চলমান',
  'pages.searchTable.nameStatus.online': 'অনলাইন',
  'pages.searchTable.nameStatus.abnormal': 'অস্বাভাবিক',
  'pages.searchTable.titleUpdatedAt': 'সর্বশেষ নির্ধারিত',
  'pages.searchTable.exception': 'ব্যতিক্রম জন্য কারণ লিখুন!',
  'pages.searchTable.titleOption': 'অপশন',
  'pages.searchTable.config': 'কনফিগারেশন',
  'pages.searchTable.subscribeAlert': 'সতর্কতা সাবস্ক্রাইব করুন',
  'pages.searchTable.title': 'ইনকয়েরি ফরম',
  'pages.searchTable.new': 'নতুন',
  'pages.searchTable.chosen': 'নির্বাচিত',
  'pages.searchTable.item': 'আইটেম',
  'pages.searchTable.totalServiceCalls': 'পরিষেবা কলগুলির মোট সংখ্যা',
  'pages.searchTable.tenThousand': '000',
  'pages.searchTable.batchDeletion': 'একসাখে ডিলিট',
  'pages.searchTable.batchApproval': 'একসাখে অনুমোদন',
  'pages.searchTable.selectToDelete': 'মুছতে আইটেম বেছে নিন',

  'pages.403.subTitle': 'দুঃখিত, এই পৃষ্ঠায় প্রবেশের অনুমতি নেই।',
  'pages.403.buttonText': 'হোমে ফিরুন',

  'pages.netValueSolution.customParams.button': 'কাস্টম প্যারামিটার',
  'pages.netValueSolution.customParams.title': 'কাস্টম প্যারামিটার',
  'pages.netValueSolution.customParams.back': 'ফিরে যান',
  'pages.netValueSolution.customParams.col.name': 'প্রদর্শন নাম',
  'pages.netValueSolution.customParams.col.paramKey': 'বিজনেস কী',
  'pages.netValueSolution.customParams.col.paramValue': 'মান',
  'pages.netValueSolution.customParams.col.order': 'ক্রম',
  'pages.netValueSolution.customParams.col.action': 'অপারেশন',
  'pages.netValueSolution.customParams.col.deductionItem': 'কর্তন আইটেম',
  'pages.netValueSolution.customParams.col.calcCondition': 'গণনার শর্ত',
  'pages.netValueSolution.customParams.col.calcFormula': 'গণনার সূত্র',
  'pages.netValueSolution.customParams.action.edit': 'সম্পাদনা',
  'pages.netValueSolution.customParams.action.delete': 'মুছুন',
  'pages.netValueSolution.planDetailLoading': 'পরিকল্পনার বিবরণ লোড হচ্ছে…',
  'pages.netValueSolution.customParams.missingPlanId': 'পরিকল্পনার তথ্য নেই। তালিকায় ফিরে যাচ্ছি।',
  'pages.netValueSolution.customParams.needSavedPlan': 'কাস্টম প্যারামিটার আগে পরিকল্পনা সংরক্ষণ করুন।',
  'pages.netValueSolution.customParams.addButton': 'কাস্টম প্যারামিটার যোগ করুন',
  'pages.netValueSolution.customParams.modalAddTitle': 'কাস্টম প্যারামিটার যোগ করুন',
  'pages.netValueSolution.customParams.modalEditTitle': 'কাস্টম প্যারামিটার সম্পাদনা',
  'pages.netValueSolution.customParams.confirmDelete': 'এই প্যারামিটার মুছবেন?',
  'pages.netValueSolution.customParams.loadListFailed': 'লোড ব্যর্থ',
  'pages.netValueSolution.customParams.saveSuccess': 'সংরক্ষিত',
  'pages.netValueSolution.customParams.saveFailed': 'সংরক্ষণ ব্যর্থ',
  'pages.netValueSolution.customParams.saving': 'সংরক্ষণ হচ্ছে…',
  'pages.netValueSolution.customParams.loadingDetail': 'বিবরণ লোড হচ্ছে…',
  'pages.netValueSolution.customParams.loadDetailFailed': 'বিবরণ লোড ব্যর্থ',
  'pages.netValueSolution.customParams.deleteSuccess': 'মুছে ফেলা হয়েছে',
  'pages.netValueSolution.customParams.deleteFailed': 'মুছতে ব্যর্থ',
  'pages.netValueSolution.customParams.rules.name': 'প্রদর্শন নাম লিখুন',
  'pages.netValueSolution.customParams.rules.paramKey': 'বিজনেস কী লিখুন',
  'pages.netValueSolution.customParams.rules.orderIndex': 'ক্রম লিখুন',
  'pages.netValueSolution.deduction.modalAdd': 'কর্তন আইটেম যোগ করুন',
  'pages.netValueSolution.deduction.modalEdit': 'কর্তন আইটেম সম্পাদনা',
  'pages.netValueSolution.deduction.modalAddTaxRate': 'ট্যাক্স রেট যোগ করুন',
  'pages.netValueSolution.table.confirmDelete': 'এই সারি মুছবেন?',
  'pages.netValueSolution.table.confirmDeleteWithChildren':
    'এই সারি মুছবেন? সম্পর্কিত সব চাইল্ড সারিও মুছে যাবে।',
  'pages.netValueSolution.formulaConfig.title': 'গণনার সূত্র কনফিগার করুন',
  'pages.netValueSolution.add.pageTitle': 'পরিকল্পনা যোগ করুন',
  'pages.netValueSolution.edit.pageTitle': 'পরিকল্পনা সম্পাদনা',
  'pages.netValueSolution.taxCard.title': 'ট্যাক্স কর্তন আইটেম',
  'pages.netValueSolution.conditionRequired': 'কমপক্ষে একটি গণনার শর্ত বেছে নিন',
  'pages.netValueSolution.taxModal.deductionNameRequired': 'কর্তন আইটেমের নাম লিখুন',
  'pages.netValueSolution.taxModal.childConditionRequired':
    'উপ-আইটেমের জন্য সংরক্ষণের আগে কমপক্ষে একটি গণনা শর্ত নির্বাচন বা পূরণ করুন',
  'pages.netValueSolution.taxModal.formulaRequired':
    'সংরক্ষণের আগে গণনার সূত্র কনফিগার করুন',
  'pages.netValueSolution.message.savePlanSuccess': 'পরিকল্পনা সংরক্ষিত হয়েছে',
  'pages.netValueSolution.message.addDeductionSuccess': 'কর্তন আইটেম যোগ হয়েছে',
  'pages.netValueSolution.message.loadDetailFailed': 'পরিকল্পনার বিবরণ লোড ব্যর্থ',
  'pages.netValueSolution.message.defaultItemCannotDelete': 'ডিফল্ট সমন্বয় আইটেম মুছতে পারবেন না',
  'pages.netValueSolution.message.taxRateMax100': 'ট্যাক্স রেট ১০০ এর বেশি হতে পারবে না',
  'pages.netValueSolution.message.dataAbnormalRetry': 'ডেটা ত্রুটি। বন্ধ করে আবার চেষ্টা করুন।',
  'pages.netValueSolution.message.updateTaxRateSuccess': 'ট্যাক্স রেট আপডেট হয়েছে',
  'pages.netValueSolution.message.addTaxRateSuccess': 'ট্যাক্স রেট যোগ হয়েছে',
  'pages.netValueSolution.message.checkRequiredFieldsEmpty': 'সব বাধ্যতামূলক ক্ষেত্র পূরণ করুন',
  'pages.netValueSolution.message.checkRequiredFieldsWithDetails': 'নিম্নলিখিত বাধ্যতামূলক ক্ষেত্র ঠিক করুন: {details}',
  'pages.netValueSolution.message.selectAtLeastOneDeduction': 'জমা দিতে কমপক্ষে একটি কর্তন আইটেম বেছে নিন',
  'pages.netValueSolution.message.unknownField': 'অজানা ক্ষেত্র',
  'pages.netValueSolution.addForm.label.cityName': 'প্রযোজ্য শহর',
  'pages.netValueSolution.addForm.label.provinceCode': 'প্রযোজ্য প্রদেশ',
  'pages.netValueSolution.addForm.label.bankId': 'প্রযোজ্য ব্যাংক',
  'pages.netValueSolution.addForm.label.businessLines': 'ব্যবসায়িক ক্ষেত্র',
  'pages.netValueSolution.addForm.label.businessType': 'ব্যবসার ধরন',
  'pages.netValueSolution.addForm.label.netWorthName': 'বন্ধকী নিট মূল্য',
  'pages.netValueSolution.addForm.label.organizationId': 'প্রযোজ্য প্রতিষ্ঠান',
  'pages.netValueSolution.addForm.rules.selectCity': 'প্রযোজ্য শহর বেছে নিন',
  'pages.netValueSolution.addForm.rules.selectProvince': 'প্রদেশ নির্বাচন করুন',
  'pages.netValueSolution.addForm.rules.selectBank': 'প্রযোজ্য ব্যাংক বেছে নিন',
  'pages.netValueSolution.addForm.rules.selectBusinessLines': 'ব্যবসায়িক ক্ষেত্র বেছে নিন',
  'pages.netValueSolution.addForm.rules.selectBusinessType': 'ব্যবসার ধরন বেছে নিন',
  'pages.netValueSolution.addForm.rules.selectNetWorth': 'বন্ধকী নিট মূল্য বেছে নিন',
  'pages.netValueSolution.addForm.rules.selectOrganization': 'প্রযোজ্য প্রতিষ্ঠান বেছে নিন',
  'pages.netValueSolution.addForm.placeholder.selectProvince': 'প্রদেশ বেছে নিন',
  'pages.netValueSolution.addForm.placeholder.selectCity': 'শহর বেছে নিন',
  'pages.netValueSolution.addForm.placeholder.selectBank': 'প্রযোজ্য ব্যাংক বেছে নিন',
  'pages.netValueSolution.addForm.placeholder.selectBusinessLines': 'ব্যবসায়িক ক্ষেত্র বেছে নিন',
  'pages.netValueSolution.addForm.placeholder.selectBusinessType': 'ব্যবসার ধরন বেছে নিন',
  'pages.netValueSolution.addForm.placeholder.selectNetWorth': 'বন্ধকী নিট মূল্য বেছে নিন',
  'pages.netValueSolution.addForm.placeholder.selectOrganization': 'প্রযোজ্য প্রতিষ্ঠান বেছে নিন',
  'pages.netValueSolution.addForm.alertLine1':
    'ডিফল্ট পদ্ধতি সিস্টেমের হিসাব; ব্যবহারকারীর সেটিং না মিললে সিস্টেম কর মান ডিফল্ট দিয়ে গণনা করে।',
  'pages.netValueSolution.addForm.alertLine2':
    'কর কাটায় কাস্টম কর্তন যোগ করা যায়; হিসাব ডিফল্ট পদ্ধতিতে।',
  'pages.netValueSolution.addForm.alertLine3':
    'কর আইটেম যোগ করলে সংশ্লিষ্ট করের একাধিক হারের পরিস্থিতি যোগ হয়।',
  'pages.netValueSolution.addNewDeduction': 'কর্তন আইটেম যোগ করুন',

  'pages.netValueSolution.list.title': 'নিট মূল্য পরিকল্পনা',
  'pages.netValueSolution.list.addButton': 'পরিকল্পনা যোগ করুন',
  'pages.netValueSolution.list.loadListFailed': 'তালিকা লোড ব্যর্থ',
  'pages.netValueSolution.list.loadListFailedRetry': 'লোড ব্যর্থ। আবার চেষ্টা করুন।',
  'pages.netValueSolution.list.missingPlanId': 'পরিকল্পনা ID পাওয়া যায়নি',
  'pages.netValueSolution.list.confirmDeleteTitle': 'মুছে ফেলা নিশ্চিত করুন',
  'pages.netValueSolution.list.confirmDeleteContent':
    'ডেটা পুনরুদ্ধার করা যাবে না। এই পরিকল্পনা মুছবেন?',
  'pages.netValueSolution.list.deleteItemLabel': 'পরিকল্পনা «{name}»',
  'pages.netValueSolution.list.edit': 'সম্পাদনা',
  'pages.netValueSolution.list.copy': 'কপি',
  'pages.netValueSolution.list.col.province': 'প্রদেশ',
  'pages.netValueSolution.list.col.city': 'শহর',
  'pages.netValueSolution.list.col.bank': 'ব্যাংক',
  'pages.netValueSolution.list.col.businessLines': 'ব্যবসায়িক ক্ষেত্র',
  'pages.netValueSolution.list.col.businessType': 'ব্যবসার ধরন',
  'pages.netValueSolution.list.col.organization': 'প্রতিষ্ঠান',
  'pages.netValueSolution.list.col.netWorthName': 'নিট মূল্য নাম',
  'pages.netValueSolution.list.col.deductItems': 'কর কর্তন',
  'pages.netValueSolution.list.col.action': 'অপারেশন',
  'pages.netValueSolution.list.ph.province': 'প্রদেশ বেছে নিন',
  'pages.netValueSolution.list.ph.city': 'শহর বেছে নিন',
  'pages.netValueSolution.list.ph.bank': 'ব্যাংক বেছে নিন',
  'pages.netValueSolution.list.ph.businessLines': 'ক্ষেত্র বেছে নিন',
  'pages.netValueSolution.list.ph.businessType': 'ধরন বেছে নিন',
  'pages.netValueSolution.list.ph.organization': 'প্রতিষ্ঠান বেছে নিন',
  'pages.netValueSolution.list.ph.netWorthName': 'নিট মূল্য নাম বেছে নিন',
  'pages.netValueSolution.list.paginationTotal': '{total} এর মধ্যে {start}-{end}',

  'pages.universalParams.title': 'ইউনিভার্সাল প্যারামিটার',
  'pages.universalParams.addButton': 'প্যারামিটার যোগ করুন',
  'pages.universalParams.col.orderIndex': 'ক্রম',
  'pages.universalParams.col.name': 'নাম',
  'pages.universalParams.col.description': 'বিবরণ',
  'pages.universalParams.col.value': 'মান',
  'pages.universalParams.col.action': 'অপারেশন',
  'pages.universalParams.loadListFailed': 'তালিকা লোড ব্যর্থ',
  'pages.universalParams.loadDetailFailed': 'বিবরণ লোড ব্যর্থ',
  'pages.universalParams.confirmDeleteTitle': 'মুছে ফেলা নিশ্চিত',
  'pages.universalParams.confirmDeleteDesc': 'প্যারামিটার «{name}» মুছবেন?',
  'pages.universalParams.modal.addTitle': 'ইউনিভার্সাল প্যারামিটার যোগ',
  'pages.universalParams.modal.editTitle': 'ইউনিভার্সাল প্যারামিটার সম্পাদনা',
  'pages.universalParams.form.name': 'নাম',
  'pages.universalParams.form.namePlaceholder': 'প্রদর্শন নাম',
  'pages.universalParams.form.description': 'বিবরণ',
  'pages.universalParams.form.descriptionPlaceholder': 'ঐচ্ছিক',
  'pages.universalParams.form.value': 'মান',
  'pages.universalParams.form.valuePlaceholder': 'tb_task_record.appraisal_value',
  'pages.universalParams.form.orderIndex': 'ক্রম',
  'pages.universalParams.form.orderPlaceholder': 'ছোট সংখ্যা আগে',
  'pages.universalParams.rules.nameRequired': 'প্যারামিটার নাম লিখুন',
  'pages.universalParams.rules.valueRequired': 'মান লিখুন',
  'pages.universalParams.rules.valueFormat':
    'tb_টেবিল.ফিল্ড (ছোট হাতের ও আন্ডারস্কোর) হতে হবে, যেমন tb_task_record.appraisal_value',
  'pages.universalParams.extra.valueHint':
    'সূত্রে PARAM কী tb_ উপসর্গ টেবিল.ফিল্ড মিলতে হবে, যেমন tb_task_record.value',

  'pages.system.logs.headerTitle': 'Operation logs',
  'pages.system.logs.col.modelName': 'Module',
  'pages.system.logs.col.apiName': 'Content',
  'pages.system.logs.col.userName': 'Operator',
  'pages.system.logs.col.requestIp': 'Request IP',
  'pages.system.logs.col.status': 'Status',
  'pages.system.logs.col.createTime': 'Time',
  'pages.system.logs.col.timeRange': 'Time range',
  'pages.system.logs.ph.module': 'Select module',
  'pages.system.logs.ph.userName': 'Enter operator name',
  'pages.system.logs.fetchModulesFailed': 'Failed to load operation modules',
  'pages.system.permission.addButton': 'Add permission',
  'pages.system.permission.col.name': 'Permission name',
  'pages.system.permission.col.desc': 'Description',
  'pages.system.permission.col.action': 'Actions',
  'pages.system.permission.configureApi': 'Configure API',
  'pages.system.permission.deleteItemName': 'Permission “{name}”',
  'pages.system.permission.batchSelected': '{count} permission(s) selected',
  'pages.system.permission.apiConfigSuccess': 'API permissions saved',
  'pages.system.permission.apiConfigFailed': 'Failed to save API permissions',
  'pages.system.permission.apiConfigFailedRetry': 'Failed to save API permissions. Please try again.',
  'pages.system.permission.apiModalTitle': 'Configure API permissions - {name}',
  'pages.system.permission.selectToDelete': 'Select permissions to delete',
  'pages.system.role.col.name': 'Role name',
  'pages.system.role.col.description': 'Description',
  'pages.system.role.col.action': 'Actions',
  'pages.system.role.deleteItemName': 'Role [{name}]',
  'pages.system.role.batchSelected': '{count} role(s) selected',
  'pages.system.role.configurePermission': 'Configure permissions',
  'pages.system.role.configureMenuPermission': 'Configure menu permissions',
  'pages.system.role.apiConfigSuccess': 'API permissions saved',
  'pages.system.role.permissionConfigSuccess': 'Permissions saved',
  'pages.system.role.menuPermissionConfigSuccess': 'Menu permissions saved',
  'pages.system.role.deleteFailedCount': '{count} role(s) failed to delete',
  'pages.system.menu.col.name': 'Name',
  'pages.system.menu.col.code': 'Code',
  'pages.system.menu.col.action': 'Actions',
  'pages.system.menu.addButton': 'Add menu',
  'pages.system.menu.addSubMenu': 'Add sub-menu',
  'pages.system.menu.deleteItemName': 'Menu “{name}”',

  'pages.system.dept.pageTitle': 'Departments',
  'pages.system.dept.refresh': 'Refresh',
  'pages.system.dept.addDept': 'Add department',
  'pages.system.dept.addChildDept': 'Add sub-department',
  'pages.system.dept.editDept': 'Edit department',
  'pages.system.dept.treeTitle': 'Department tree',
  'pages.system.dept.orgCount': '{count} organization(s)',
  'pages.system.dept.emptyTree': 'No department data',
  'pages.system.dept.detailDept': 'Department details',
  'pages.system.dept.detailOrg': 'Organization details',
  'pages.system.dept.edit': 'Edit',
  'pages.system.dept.delete': 'Delete',
  'pages.system.dept.label.deptName': 'Department name',
  'pages.system.dept.label.deptId': 'Department ID',
  'pages.system.dept.label.parentDept': 'Parent department',
  'pages.system.dept.label.status': 'Status',
  'pages.system.dept.label.childCount': 'Sub-departments',
  'pages.system.dept.label.ownerOrg': 'Organization / customer',
  'pages.system.dept.label.orgName': 'Organization / customer name',
  'pages.system.dept.label.orgId': 'Organization / customer ID',
  'pages.system.dept.label.ownerType': 'Type',
  'pages.system.dept.type.organization': 'Organization',
  'pages.system.dept.type.customer': 'Customer',
  'pages.system.dept.status.enabled': 'Enabled',
  'pages.system.dept.status.disabled': 'Disabled',
  'pages.system.dept.parentRoot': 'None (root)',
  'pages.system.dept.selectNodeHint': 'Select a department or organization on the left',
  'pages.system.dept.unnamedDept': 'Unnamed department',
  'pages.system.dept.ungrouped': 'Ungrouped',
  'pages.system.dept.unnamed': 'Unnamed',
  'pages.system.dept.fetchTreeFail': 'Failed to load department tree',
  'pages.system.dept.fetchTreeFailRetry': 'Failed to load department tree. Please try again later.',
  'pages.system.dept.cannotDeleteInvalid': 'Cannot delete an invalid department node',
  'pages.system.dept.cannotDeleteRoot': 'Root department cannot be deleted',
  'pages.system.dept.defaultItemName': 'department',
  'pages.system.dept.deleteTitle': 'Delete this department?',
  'pages.system.dept.deleteContent':
    'This cannot be undone. Sub-departments under it will be affected.',
  'pages.system.dept.deleteSuccess': 'Deleted',
  'pages.system.dept.deleteFail': 'Delete failed',
  'pages.system.dept.deleteFailRetry': 'Delete failed. Please try again.',
  'pages.system.dept.editMissingOwner': 'Missing organization/customer for this department. Refresh and try again.',
  'pages.system.dept.saveSuccessEdit': 'Department updated',
  'pages.system.dept.saveSuccessAdd': 'Department created',
  'pages.system.dept.saveFail': 'Save failed',
  'pages.system.dept.form.name': 'Department name',
  'pages.system.dept.form.nameRequired': 'Enter department name',
  'pages.system.dept.form.nameMax': 'Name must be 50 characters or less',
  'pages.system.dept.form.namePlaceholder': 'Enter department name',
  'pages.system.dept.form.ownerOrg': 'Organization',
  'pages.system.dept.form.ownerOrgRequired': 'Select an organization',
  'pages.system.dept.form.ownerOrgPlaceholder': 'Select an organization',
  'pages.system.dept.form.ownerOrgCustomer': 'Organization / customer',
  'pages.system.dept.form.ownerSelectedPlaceholder': 'Selected organization / customer',
  'pages.system.dept.form.parentDept': 'Parent department',
  'pages.system.dept.form.parentDeptPlaceholder': 'Select parent department',

  'pages.operations.statTotalCustomers': 'Total customers',
  'pages.operations.statNewThisMonth': 'New this month',
  'pages.operations.statPendingTasks': 'Pending tasks',
  'pages.operations.statReportsDone': 'Reports completed',
  'pages.operations.taskRateTitle': 'Task completion',
  'pages.operations.recentActivityTitle': 'Recent activity',
  'pages.operations.col.time': 'Time',
  'pages.operations.col.activity': 'Activity',
  'pages.operations.col.operator': 'Operator',
  'pages.operations.col.status': 'Status',
  'pages.operations.taskName.evaluation': 'Customer evaluation',
  'pages.operations.taskName.report': 'Report generation',
  'pages.operations.taskName.finance': 'Finance review',
  'pages.operations.taskName.maintenance': 'System maintenance',
  'pages.operations.status.done': 'Done',
  'pages.operations.status.inProgress': 'In progress',
  'pages.operations.systemStatusTitle': 'System status',
  'pages.operations.cpuUsage': 'CPU usage',
  'pages.operations.memoryUsage': 'Memory usage',
  'pages.operations.diskUsage': 'Disk usage',
  'pages.operations.demo.action1': 'New customer evaluation task',
  'pages.operations.demo.action2': 'Finance report review completed',
  'pages.operations.demo.action3': 'System maintenance update',
  'pages.operations.demo.action4': 'Customer satisfaction survey',
  'pages.operations.demo.user1': 'Zhang',
  'pages.operations.demo.user2': 'Li',
  'pages.operations.demo.user3': 'Wang',
  'pages.operations.demo.user4': 'Zhao',
  'pages.finance.tooltip.view': 'View',
  'pages.finance.tooltip.edit': 'Edit',
  'pages.finance.tooltip.delete': 'Delete',
  'pages.finance.stat.totalIncome': 'Total income',
  'pages.finance.stat.totalExpense': 'Total expense',
  'pages.finance.stat.netIncome': 'Net income',
  'pages.finance.modal.add': 'Add finance record',
  'pages.finance.modal.edit': 'Edit finance record',
  'pages.finance.addRecord': 'Add record',
  'pages.finance.paginationTotal': 'Items {start}-{end} of {total}',
  'pages.platform.tooltip.view': 'View',
  'pages.platform.tooltip.edit': 'Edit',
  'pages.platform.tooltip.delete': 'Delete',
  'pages.platform.modal.add': 'Add maintenance record',
  'pages.platform.modal.edit': 'Edit maintenance record',
  'pages.platform.addRecord': 'Add maintenance',
  'pages.platform.paginationTotal': '{total} records',
  'pages.platform.column.id': 'ID',
  'pages.platform.column.title': 'Title',
  'pages.platform.column.type': 'Type',
  'pages.platform.column.priority': 'Priority',
  'pages.platform.column.status': 'Status',
  'pages.platform.column.progress': 'Progress',
  'pages.platform.column.assignee': 'Assignee',
  'pages.platform.column.createTime': 'Created',
  'pages.platform.column.estimatedTime': 'Est. completion',
  'pages.platform.column.action': 'Actions',
  'pages.platform.overview.ok': 'System OK',
  'pages.platform.overview.running': 'Running',
  'pages.platform.overview.attention': 'Attention',
  'pages.platform.overview.error': 'Error',
  'pages.platform.alert.title': 'System status',
  'pages.platform.alert.cpu': 'CPU',
  'pages.platform.alert.memory': 'Memory',
  'pages.platform.alert.disk': 'Disk',
  'pages.platform.alert.network': 'Network',
  'pages.platform.alert.networkOk': 'OK',
  'pages.platform.filter.searchPlaceholder': 'Search title or description',
  'pages.platform.filter.typePlaceholder': 'Type',
  'pages.platform.filter.statusPlaceholder': 'Status',
  'pages.platform.filter.priorityPlaceholder': 'Priority',
  'pages.platform.filter.assigneePlaceholder': 'Filter by assignee',
  'pages.platform.type.all': 'All types',
  'pages.platform.type.performance': 'Performance',
  'pages.platform.type.security': 'Security',
  'pages.platform.type.hardware': 'Hardware',
  'pages.platform.status.all': 'All statuses',
  'pages.platform.status.pending': 'Pending',
  'pages.platform.status.ongoing': 'In progress',
  'pages.platform.status.completed': 'Completed',
  'pages.platform.priority.all': 'All priorities',
  'pages.platform.priority.high': 'High',
  'pages.platform.priority.medium': 'Medium',
  'pages.platform.priority.low': 'Low',
  'pages.platform.stat.total': 'Total records',
  'pages.platform.stat.completed': 'Completed',
  'pages.platform.stat.inProgress': 'In progress',
  'pages.platform.stat.pending': 'Pending',
  'pages.platform.confirmDelete': 'Confirm delete',
  'pages.platform.confirmDeleteContent': 'Delete maintenance record "{title}"?',
  'pages.platform.msg.deleteSuccess': 'Deleted',
  'pages.platform.msg.updateSuccess': 'Updated',
  'pages.platform.msg.addSuccess': 'Added',
  'pages.platform.form.title': 'Title',
  'pages.platform.form.titleRequired': 'Enter title',
  'pages.platform.form.titlePlaceholder': 'Enter title',
  'pages.platform.form.type': 'Type',
  'pages.platform.form.typeRequired': 'Select type',
  'pages.platform.form.typePerformance': 'Performance',
  'pages.platform.form.typeSecurity': 'Security',
  'pages.platform.form.typeHardware': 'Hardware',
  'pages.platform.form.typeSoftware': 'Software update',
  'pages.platform.form.priority': 'Priority',
  'pages.platform.form.priorityRequired': 'Select priority',
  'pages.platform.form.assignee': 'Assignee',
  'pages.platform.form.assigneeRequired': 'Enter assignee',
  'pages.platform.form.assigneePlaceholder': 'Enter assignee',
  'pages.platform.form.estimatedTime': 'Est. completion',
  'pages.platform.form.estimatedTimeRequired': 'Select date',
  'pages.platform.form.estimatedTimePlaceholder': 'e.g. 2024-01-20',
  'pages.platform.form.description': 'Description',
  'pages.platform.form.descriptionRequired': 'Enter description',
  'pages.platform.form.descriptionPlaceholder': 'Enter description',
  'pages.platform.form.status': 'Status',
  'pages.activity.tooltip.view': 'View',
  'pages.activity.tooltip.edit': 'Edit',
  'pages.activity.tooltip.delete': 'Delete',
  'pages.activity.modal.add': 'Add activity',
  'pages.activity.modal.edit': 'Edit activity',
  'pages.activity.addRecord': 'Add activity',
  'pages.activity.paginationTotal': '{total} records',
  'pages.activity.column.id': 'Activity ID',
  'pages.activity.column.title': 'Title',
  'pages.activity.column.type': 'Type',
  'pages.activity.column.startTime': 'Start time',
  'pages.activity.column.endTime': 'End time',
  'pages.activity.column.location': 'Location',
  'pages.activity.column.status': 'Status',
  'pages.activity.column.participants': 'Participants',
  'pages.activity.column.budget': 'Budget',
  'pages.activity.column.organizer': 'Organizer',
  'pages.activity.column.action': 'Actions',
  'pages.activity.stat.total': 'Total activities',
  'pages.activity.stat.inProgress': 'In progress',
  'pages.activity.stat.registering': 'Registration open',
  'pages.activity.stat.ended': 'Ended',
  'pages.activity.filter.searchPlaceholder': 'Search by title or organizer',
  'pages.activity.filter.typePlaceholder': 'Type',
  'pages.activity.filter.statusPlaceholder': 'Status',
  'pages.activity.filter.locationPlaceholder': 'Filter by location',
  'pages.activity.type.all': 'All types',
  'pages.activity.type.customer': 'Customer event',
  'pages.activity.type.training': 'Training',
  'pages.activity.type.meeting': 'Internal meeting',
  'pages.activity.status.all': 'All statuses',
  'pages.activity.status.planning': 'Planning',
  'pages.activity.status.registration': 'Registration open',
  'pages.activity.status.ongoing': 'In progress',
  'pages.activity.status.ended': 'Ended',
  'pages.activity.rangeStart': 'Start date',
  'pages.activity.rangeEnd': 'End date',
  'pages.activity.confirmDelete': 'Confirm delete',
  'pages.activity.confirmDeleteContent': 'Delete activity "{title}"?',
  'pages.activity.msg.deleteSuccess': 'Deleted',
  'pages.activity.msg.updateSuccess': 'Updated',
  'pages.activity.msg.addSuccess': 'Added',
  'pages.activity.form.title': 'Title',
  'pages.activity.form.titleRequired': 'Enter title',
  'pages.activity.form.titlePlaceholder': 'Enter title',
  'pages.activity.form.type': 'Type',
  'pages.activity.form.typeRequired': 'Select type',
  'pages.activity.form.organizer': 'Organizer',
  'pages.activity.form.organizerRequired': 'Enter organizer',
  'pages.activity.form.organizerPlaceholder': 'Enter organizer',
  'pages.activity.form.startTime': 'Start time',
  'pages.activity.form.startTimeRequired': 'Select start time',
  'pages.activity.form.endTime': 'End time',
  'pages.activity.form.endTimeRequired': 'Select end time',
  'pages.activity.form.location': 'Location',
  'pages.activity.form.locationRequired': 'Enter location',
  'pages.activity.form.locationPlaceholder': 'Enter location',
  'pages.activity.form.maxParticipants': 'Max participants',
  'pages.activity.form.maxParticipantsRequired': 'Enter max participants',
  'pages.activity.form.budget': 'Budget',
  'pages.activity.form.budgetRequired': 'Enter budget',
  'pages.activity.form.activityStatus': 'Status',

  'pages.customer.list.col.customerName': 'Customer name',
  'pages.customer.list.col.customerType': 'Customer type',
  'pages.customer.list.col.province': 'Province',
  'pages.customer.list.col.city': 'City',
  'pages.customer.list.col.district': 'District',
  'pages.customer.list.col.organization': 'Organization',
  'pages.customer.list.col.status': 'Status',
  'pages.customer.list.col.contact': 'Contacts',
  'pages.customer.list.col.contactPhone': 'Contact phone',
  'pages.customer.list.col.createTime': 'Created at',
  'pages.customer.list.col.updateTime': 'Updated at',
  'pages.customer.list.col.action': 'Actions',
  'pages.customer.list.confirmToggleTitle': 'Confirm {action}',
  'pages.customer.list.confirmToggleContent': 'Are you sure you want to {action} this customer?',
  'pages.customer.list.itemNamed': 'Customer "{name}"',
  'pages.customer.list.batchItemName': '{count} selected customer(s)',
  'pages.customer.list.batchContent':
    'This cannot be undone. Delete the selected customers?',
  'pages.customer.list.batchResultAllSuccess': 'Deleted {success} customer(s)',
  'pages.customer.list.batchResultPartial': 'Deleted {success} customer(s), {fail} failed',
  'pages.customer.list.batchFailed': 'Batch delete failed',
  'pages.customer.list.exportOrgTemplate': 'Organization customer template',
  'pages.customer.list.exportPersonalTemplate': 'Individual customer template',
  'pages.customer.list.exportUserTemplate': 'Customer user template',
  'pages.customer.list.exportTemplate': 'Download template',
  'pages.customer.list.importCustomer': 'Import customers',
  'pages.customer.list.importCustomerUser': 'Import customer users',
  'pages.customer.list.addCustomer': 'Add customer',
  'pages.customer.list.fileNameOrgTemplate': 'organization-customer-import.xlsx',
  'pages.customer.list.fileNamePersonalTemplate': 'personal-customer-import.xlsx',
  'pages.customer.list.fileNameUserTemplate': 'customer-user-import.xlsx',
  'pages.customer.list.deleteContent':
    'This cannot be undone. Delete this customer?',
  'pages.customer.list.toggleSuccess': '{action} succeeded',
  'pages.customer.list.toggleFail': '{action} failed',
  'pages.taskMgmt.col.taskNumber': 'Task number',
  'pages.taskMgmt.col.reportNumber': 'Report number',
  'pages.taskMgmt.col.taskName': 'Task name',
  'pages.taskMgmt.col.specialSituation': 'Special situation',
  'pages.taskMgmt.col.taskStatus': 'Task status',
  'pages.taskMgmt.col.creator': 'Creator',
  'pages.taskMgmt.col.currentOperator': 'Current operator',
  'pages.taskMgmt.col.province': 'Province',
  'pages.taskMgmt.col.city': 'City',
  'pages.taskMgmt.col.district': 'District',
  'pages.taskMgmt.col.createTime': 'Created at',
  'pages.taskMgmt.col.action': 'Actions',
  'pages.taskMgmt.action.view': 'View',
  'pages.taskMgmt.action.edit': 'Edit',
  'pages.taskMgmt.unknownStatus': 'Unknown status',
  'pages.taskMgmt.createLoading': 'Creating task…',
  'pages.taskMgmt.createFail': 'Failed to create task. Please try again.',
  'pages.taskMgmt.deleteTitle': 'Confirm delete',
  'pages.taskMgmt.deleteContent': 'Delete task "{name}"?',
  'pages.taskMgmt.noTaskId': 'Task ID missing; cannot delete',
  'pages.taskMgmt.redoTitle': 'Confirm redo',
  'pages.taskMgmt.redoContent': 'Redo task "{name}"?',
  'pages.taskMgmt.redoSuccess': 'Task redone',
  'pages.taskMgmt.fetchListFail': 'Failed to load task list',
  'pages.taskMgmt.fetchListFailRetry': 'Failed to load task list. Please try again.',
  'pages.taskMgmt.modalAddTitle': 'New task',
  'pages.taskMgmt.formTaskName': 'Task name',
  'pages.taskMgmt.formTaskNameMax': 'Name must be 100 characters or less',
  'pages.taskMgmt.formTaskNamePlaceholder': 'Task name (optional)',
  'pages.taskMgmt.paginationTotal': 'Items {start}-{end} of {total}',
  'pages.report.col.electronicCode': 'Electronic report code',
  'pages.report.col.estimateCode': 'Report number',
  'pages.report.col.taskName': 'Task name',
  'pages.report.col.state': 'Status',
  'pages.report.col.creator': 'Creator',
  'pages.report.col.operator': 'Current operator',
  'pages.report.col.organization': 'Organization',
  'pages.report.col.province': 'Province',
  'pages.report.col.city': 'City',
  'pages.report.col.district': 'District',
  'pages.report.col.createTime': 'Created at',
  'pages.report.col.action': 'Actions',
  'pages.report.state.all': 'All',
  'pages.report.state.pendingFirst': 'First review pending',
  'pages.report.state.pendingSecond': 'Second review pending',
  'pages.report.state.pendingThird': 'Third review pending',
  'pages.report.state.pendingSeal': 'Pending seal',
  'pages.report.state.pendingModify': 'Pending modification',
  'pages.report.state.done': 'Completed',
  'pages.report.state.pendingArchive': 'Pending archive',
  'pages.report.state.void': 'Void',
  'pages.report.state.completedEnd': 'Closed',
  'pages.report.state.pendingReview': 'Pending review',
  'pages.report.state.reviewed': 'Reviewed',
  'pages.report.state.sealPending': 'Pending seal',
  'pages.report.state.sealed': 'Sealed',
  'pages.report.process.pending': 'Pending',
  'pages.report.process.done': 'Processed',
  'pages.report.review.addDev': 'New report feature is under development…',
  'pages.report.action.review': 'Review',
  'pages.report.action.sign': 'Sign',
  'pages.ledger.list.title': 'Ledger records',
  'pages.ledger.list.fetchFail': 'Failed to load ledger list',
  'pages.ledger.list.directConnect': 'Direct connect',
  'pages.ledger.list.tokenRequired': 'Enter third-party platform token',
  'pages.ledger.list.syncFail': 'Sync failed',
  'pages.ledger.list.directConnectDone': 'Direct connect completed',
  'pages.ledger.list.directConnectAlready': 'This ledger already completed direct connect',
  'pages.ledger.list.initFail': 'Initialization failed',
  'pages.ledger.list.initNoFileId': 'Initialization did not return fileId; cannot save binding',
  'pages.ledger.list.saveBindFail': 'Save and bind failed',
  'pages.ledger.list.flowFail': 'Handover review failed',
  'pages.ledger.list.flowTimeout': 'Review workflow timed out. Please try again later.',
  'pages.ledger.list.editDirectFail': 'Edit and direct connect failed',
  'pages.ledger.list.searchConfigSaved': 'Search field configuration saved',
  'pages.ledger.list.ph.province': 'Select province',
  'pages.ledger.list.ph.city': 'Select city',
  'pages.ledger.list.ph.district': 'Select district',
  'pages.ledger.list.ph.street': 'Select street',
  'pages.ledger.list.notFoundData': 'No data',
  'pages.ledger.list.notFoundSelectProvince': 'Select province first',
  'pages.ledger.list.notFoundSelectCity': 'Select city first',
  'pages.ledger.list.notFoundSelectDistrict': 'Select district first',
  'pages.ledger.list.downloadTemplate': 'Downloading template…',
  'pages.ledger.list.templateFileName': 'ledger-import-template.xlsx',
  'pages.ledger.list.exporting': 'Exporting…',
  'pages.ledger.list.exportSuccess': 'Export succeeded',
  'pages.ledger.list.exportFail': 'Export failed',

  'pages.ledger.list.batchDirectConnect': 'Batch direct connect',
  'pages.ledger.list.autoDirectConnect': 'Auto direct connect',
  'pages.ledger.list.batchDirectConnectHint': 'Start batch direct connect for {count} eligible record(s)',
  'pages.ledger.list.autoDirectConnectHint': 'The system will auto-select pending records; scope is determined by the backend',
  'pages.ledger.list.directConnectTokenLabel': 'User token (required)',
  'pages.ledger.list.directConnectFileLabel': 'File (optional; uploaded file takes priority)',
  'pages.ledger.list.directConnectSelectFile': 'Select file',
  'pages.ledger.list.batchDirectConnectSkipped': 'Skipped {count} ineligible record(s)',
  'pages.ledger.list.batchDirectConnectNoEligible': 'No eligible records to connect',
  'pages.ledger.list.batchDirectConnectStartFail': 'Failed to start batch direct connect',
  'pages.ledger.list.autoDirectConnectStartFail': 'Failed to start auto direct connect',
  'pages.ledger.list.directConnectJobTitle': 'Direct connect progress',
  'pages.ledger.list.directConnectJobStatusLabel': 'Job status',
  'pages.ledger.list.directConnectJobTotal': 'Total',
  'pages.ledger.list.directConnectJobSuccess': 'Success',
  'pages.ledger.list.directConnectJobFailed': 'Failed',
  'pages.ledger.list.directConnectJobProcessing': 'In progress',
  'pages.ledger.list.directConnectJobEmpty': 'No details',
  'pages.ledger.list.directConnectJobCompleted': 'Direct connect job completed',
  'pages.ledger.list.directConnectJobFailedMessage': 'Direct connect job failed',
  'pages.ledger.list.directConnectJobQueryFail': 'Failed to query direct connect progress',
  'pages.ledger.list.directConnectJobCloseTitle': 'Job still running',
  'pages.ledger.list.directConnectJobCloseContent': 'The job will continue in the background. Close this window?',
  'pages.ledger.list.directConnectCol.reportNumber': 'Report no.',
  'pages.ledger.list.directConnectCol.electronicReportCode': 'E-report code',
  'pages.ledger.list.directConnectCol.status': 'Status',
  'pages.ledger.list.directConnectCol.stage': 'Stage',
  'pages.ledger.list.directConnectCol.message': 'Message',
  'pages.ledger.list.directConnectJobStatus.RUNNING': 'Running',
  'pages.ledger.list.directConnectJobStatus.COMPLETED': 'Completed',
  'pages.ledger.list.directConnectJobStatus.FAILED': 'Failed',
  'pages.ledger.list.directConnectItemStatus.PENDING': 'Pending',
  'pages.ledger.list.directConnectItemStatus.RUNNING': 'Running',
  'pages.ledger.list.directConnectItemStatus.SUCCESS': 'Success',
  'pages.ledger.list.directConnectItemStatus.FAILED': 'Failed',

  'pages.system.user.col.username': 'Username',
  'pages.system.user.col.workNo': 'Employee ID',
  'pages.system.user.col.realName': 'Name',
  'pages.system.user.ph.realName': 'Search by name',
  'pages.system.user.col.email': 'Email',
  'pages.system.user.col.phone': 'Phone',
  'pages.system.user.selectToDelete': 'Select users to delete',
  'pages.system.user.batchDeleteFail': 'Batch delete failed',
  'pages.system.user.downloadTemplateLoading': 'Downloading template…',
  'pages.system.user.templateFileName': 'user-import-template.xlsx',
  'pages.system.user.templateDownloadSuccess': 'Template downloaded',
  'pages.system.user.templateDownloadFail': 'Download failed. Please try again.',
  'pages.system.user.uploadExcelOnly': 'Please upload an Excel file (.xlsx or .xls)',
  'pages.system.user.fileTooLarge': 'File size must not exceed 10MB',
  'pages.system.user.importDone': 'Import finished',
  'pages.system.user.importFail': 'Import failed',
  'pages.system.user.importFailRetry': 'Import failed. Please try again.',
  'pages.system.user.resetPwdTitle': 'Reset password?',
  'pages.system.user.resetPwdContent': 'Reset password for "{name}"?',
  'pages.system.user.resetPwdOk': 'Reset',
  'pages.system.user.resetPwdSuccess': 'Password reset',
  'pages.system.user.resetPwdFail': 'Password reset failed',
  'pages.system.user.resetPwdFailRetry': 'Password reset failed. Please try again.',

  'pages.system.user.col.nickname': 'Nickname',
  'pages.system.user.ph.nickname': 'Search by nickname',
  'pages.system.user.col.gender': 'Gender',
  'pages.system.user.gender.male': 'Male',
  'pages.system.user.gender.female': 'Female',
  'pages.system.user.gender.unknown': 'Unknown',
  'pages.system.user.col.roles': 'Roles',
  'pages.system.user.unassigned': 'Unassigned',
  'pages.system.user.col.organization': 'Organization',
  'pages.system.user.ph.organization': 'Select organization',
  'pages.system.user.col.dept': 'Department',
  'pages.system.user.ph.dept': 'Select department',
  'pages.system.user.col.status': 'Status',
  'pages.system.user.col.createTime': 'Created at',
  'pages.system.user.col.action': 'Actions',
  'pages.system.user.action.edit': 'Edit',
  'pages.system.user.action.resetPwd': 'Reset password',
  'pages.system.user.action.delete': 'Delete',
  'pages.system.user.exportTemplate': 'Export template',
  'pages.system.user.import': 'Import',
  'pages.system.user.addUser': 'Add user',
  'pages.system.user.deleteSuccess': 'Deleted',
  'pages.system.user.deleteFail': 'Delete failed',
  'pages.system.user.confirmToggleTitle': 'Confirm {action}',
  'pages.system.user.confirmToggleContent': 'Are you sure you want to {action} this user?',
  'pages.system.user.userNamed': 'User "{name}"',
  'pages.system.user.userBracketNamed': 'User [{name}]',
  'pages.system.user.batchUsers': '{count} selected user(s)',
  'pages.system.user.deleteBatchSuccess': 'Deleted {count} user(s)',
  'pages.system.user.resetPwdContentInitial':
    'Reset this user’s password to the initial password?',
  'pages.system.user.tableSelected': '{count} selected',
  'pages.system.user.batchDeleteWithCount': 'Batch delete ({count})',
  'pages.system.user.cancelSelection': 'Clear selection',
  'pages.system.user.importModalTitle': 'Import users',
  'pages.system.user.importProcessingFile': 'Processing file…',
  'pages.system.user.importDragText': 'Click or drag a file here to upload',
  'pages.system.user.importFileHintLong':
    'Single Excel file: .xlsx or .xls, up to 10MB',
  'pages.system.user.importRunning': 'Importing users…',
  'pages.system.user.importRunningHint': 'Please wait; results will appear when done',
  'pages.system.user.importInstructionsTitle': 'Import notes',
  'pages.system.user.importInstruction1': 'Download the template and fill users as required',
  'pages.system.user.importInstruction2': 'Required: username, name, email, phone',
  'pages.system.user.importInstruction3': 'Gender: male/female/unknown or 1/2/3',
  'pages.system.user.importInstruction4': 'Use correct role and organization names',
  'pages.system.user.importInstruction5': 'On errors, a failure file may be available to download',
  'pages.system.user.deptUnnamed': 'Unnamed department',
};
